import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/expediente/getProcesosExpedienteByUnidadFinalizado.php';

export default function getProcesosExpedienteByUnidadFinalizado({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}